import { getCachePath } from '@ms-cloudpack/config';
import fsPromises from 'fs/promises';
import type { CommandAction } from '../../types/CommandAction.js';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CleanOptions {}

/** Clear the Cloudpack cache. */
export const execute: CommandAction<CleanOptions> = async (params) => {
  const { options } = params;

  const cachePath = await getCachePath(options.cachePath);
  const cacheDescription = `the Cloudpack cache (${cachePath})`;

  try {
    // NOTE: if the method used here changes, be sure to update what cache.e2e.test.ts spies on
    await fsPromises.rm(cachePath, { recursive: true, force: true });
    return { message: `Successfully cleared ${cacheDescription}` };
  } catch (err) {
    return {
      message: `Failed to clear ${cacheDescription}: ${(err as Error).message || err}`,
      hasErrors: true,
    };
  }
};
